<template>
  <div class="subscription-box-order-list">
    <section class="subscription-box-production-batch-list">
      <el-breadcrumb>
        <el-breadcrumb-item>Produção</el-breadcrumb-item>
        <el-breadcrumb-item>
          <b>Lotes de montagem</b>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <el-tabs
        v-model="activeTab"
        @tab-click="tabChanged">
        <el-tab-pane label="Padrão" name="standard">
          <template slot="label">
            <div class="tab-label">
              <el-tooltip
                placement="top"
                :open-delay="300"
                :content="standardTooltipMessage"
                :disabled="!standardTooltipMessage">
                <el-badge is-dot :hidden="!standardTooltipMessage">
                  Padrão
                </el-badge>
              </el-tooltip>
            </div>
          </template>

          <subscription-box-production-batch-search-list v-if="activeTab === 'standard'" type="STANDARD"></subscription-box-production-batch-search-list>
        </el-tab-pane>
        <el-tab-pane label="Marketing" name="marketing">
          <template slot="label">
            <div class="tab-label">
              <el-tooltip
                placement="top"
                :open-delay="300"
                :content="marketingTooltipMessage"
                :disabled="!marketingTooltipMessage">
                <el-badge is-dot :hidden="!marketingTooltipMessage">
                  Marketing
                </el-badge>
              </el-tooltip>
            </div>
          </template>

          <subscription-box-production-batch-search-list v-if="activeTab === 'marketing'" type="MARKETING"></subscription-box-production-batch-search-list>
        </el-tab-pane>
      </el-tabs>
    </section>
  </div>
</template>

<script>
import lodash from 'lodash';
import moment from 'moment';

import SubscriptionBoxProductionBatchService from '@/services/fulfillment/SubscriptionBoxProductionBatchService';
import SubscriptionBoxOrderService from '@/services/fulfillment/SubscriptionBoxOrderService';
import SubscriptionBoxProductionBatchSearchList from './SearchList.vue';

function tooltipMessage(pendingBatches, pendingOrders) {
  if (!pendingBatches && !pendingOrders) {
    return null;
  }
  if (!pendingBatches) {
    return `${pendingOrders} pedidos sem lote de montagem`;
  }
  if (!pendingOrders) {
    return `${pendingBatches} lotes em produção`;
  }
  return `${pendingBatches} lotes em produção, ${pendingOrders} pedidos sem lote de montagem`;
}

export default {
  name: 'subscription-box-production-batch-list',
  components: {
    SubscriptionBoxProductionBatchSearchList,
  },
  data() {
    return {
      activeTab: 'standard',
      standardPendingOrders: null,
      standardPendingBatches: null,
      marketingPendingOrders: null,
      marketingPendingBatches: null,
    };
  },
  computed: {
    standardTooltipMessage() {
      return tooltipMessage(this.standardPendingBatches, this.standardPendingOrders);
    },
    marketingTooltipMessage() {
      return tooltipMessage(this.marketingPendingBatches, this.marketingPendingOrders);
    },
  },
  methods: {
    tabChanged(tab) {
      this.activeTab = tab.name;
      this.$router.replace(
        {
          query: {
            tab: this.activeTab,
          },
        },
      );
    },

  },
  created() {
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab;
    }

    const status = ['PLANNED', 'PRODUCTS_SELECTED', 'IN_PRODUCTION', 'READY_TO_POST'];

    SubscriptionBoxOrderService.getCountAvailableForNextBatch(null, 'STANDARD')
      .then(result => {
        this.standardPendingOrders = result.availableOrders;
      });
    SubscriptionBoxOrderService.getCountAvailableForNextBatch(null, 'MARKETING')
      .then(result => {
        this.marketingPendingOrders = result.availableOrders;
      });

    SubscriptionBoxProductionBatchService.getCounts(['STANDARD'], status)
      .then(result => {
        this.standardPendingBatches = lodash.reduce(result, (sum, item) => sum + item, 0);
      });
    SubscriptionBoxProductionBatchService.getCounts(['MARKETING'], status)
      .then(result => {
        this.marketingPendingBatches = lodash.reduce(result, (sum, item) => sum + item, 0);
      });
  },
};
</script>
<style lang="scss">
.subscription-box-order-list {
  .tab-label {
    padding: 4px 0 4px;
  }
  .el-tabs__item {
    height: 48px !important;
  }
}
</style>
